
export default {
  name: 'FreebieCounter',
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
};
